import Checkbox from './Checkbox'

// simplifies importing elsewhere
export default Checkbox
